export default {
  CREATED: 201,
  BAD_GATEWAY: 502,
  BAD_REQUEST: 400,
  MULTIPLE_CHOICES: 300,
  OK: 200,
  UNAUTHORIZED: 401
};
